import _ from 'lodash'
import { d } from 'core/service/lib/decimal'
import riderMessages from 'core/data-model/constants/validation-messages'

export const constraintStepSumAssuredRule = (rule, eligibilities) => {
  let errorMessage = ''

  const riderSumAssured = eligibilities.rider.sumAssured
  const result = d(riderSumAssured)
    .mod(rule.value)
    .toNumber()

  if (result !== 0) {
    let messageId = `RULE_RIDER_${eligibilities.rider.code}_LIMIT_INCREASING`
    errorMessage = _.get(riderMessages, messageId) || riderMessages.RULE_MESSAGE_NOT_FOUND
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
